// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "atmosphereFragmentDeclaration";
const shader = `uniform vec3 peakRayleighScattering;
uniform float planetRadius;
uniform vec3 peakMieScattering;
uniform float atmosphereThickness;
uniform vec3 peakMieAbsorption;
uniform float planetRadiusSquared;
uniform vec3 peakMieExtinction;
uniform float atmosphereRadius;
uniform vec3 peakOzoneAbsorption;
uniform float atmosphereRadiusSquared;
uniform float horizonDistanceToAtmosphereEdge;
uniform float horizonDistanceToAtmosphereEdgeSquared;
uniform float planetRadiusWithOffset;
uniform float planetRadiusOffset;
uniform float atmosphereExposure;
uniform float aerialPerspectiveRadianceBias;
uniform float inverseAtmosphereThickness;
uniform float aerialPerspectiveTransmittanceScale;
uniform mat4 inverseViewProjectionWithoutTranslation;
uniform vec3 directionToLight;
uniform float multiScatteringIntensity;
uniform vec3 directionToLightRelativeToCameraGeocentricNormal;
uniform float cameraRadius;
uniform vec3 lightRadianceAtCamera;
uniform float diffuseSkyIrradianceDesaturationFactor;
uniform vec3 groundAlbedo;
uniform float aerialPerspectiveSaturation;
uniform vec3 minMultiScattering;
uniform float diffuseSkyIrradianceIntensity;
uniform vec3 cameraPositionGlobal;
uniform float lightIntensity;
uniform vec3 clampedCameraPositionGlobal;
uniform float aerialPerspectiveIntensity;
uniform vec3 cameraGeocentricNormal;
uniform float clampedCameraRadius;
uniform vec3 cameraForward;
uniform float clampedCameraHeight;
uniform vec3 cameraPosition;
uniform float cosCameraHorizonAngleFromZenith;
uniform vec4 viewport;
uniform vec3 additionalDiffuseSkyIrradiance;
uniform float cameraHeight;
uniform float cameraNearPlane;
uniform float originHeight;
uniform float sinCameraAtmosphereHorizonAngleFromNadir;
uniform float transmittanceSampleCount;
uniform float skyViewLutSampleCount;
uniform float multiScatteringLutSampleCount;
uniform float multiScatteringAzimuthSampleCount;
uniform float multiScatteringInclinationSampleCount;
uniform float diffuseSkyIrradianceLutSampleCount;`;
// Sideeffect
if (!ShaderStore.IncludesShadersStore[name]) {
    ShaderStore.IncludesShadersStore[name] = shader;
}

/** @internal */
export const atmosphereFragmentDeclaration = { name, shader };
